import { Box } from "@mui/material";
import React, { useContext, useEffect } from "react";
import QuoteList from "../../../components/QuoteComponents/Quotelist";
import QuoteRouteHeader from "../../../components/QuoteComponents/QuoteRouteHeader";
import GetShippingQuote from "../../../components/QuoteComponents/GetShippingQuote";
import { getPostpalMarkups } from "../../../helper/functions";

export default function QuotePage() {
  const [getShippingQuotes, setGetShippingQuotes] = React.useState([]);
  const [finalMarkups, setFinalMarkups] = React.useState({});
  const [formValues, setFormValues] = React.useState({});
  const [showQuote, setShowQuote] = React.useState(false);
  const getAllMarkups = async () => {
    const final = {}
    let markups = await getPostpalMarkups();
    console.log(markups,"markupsmarkupsmarkups");
    
    markups?.map((mark) => {final[mark?.id]= mark.quote_markup_rate})
    console.log(final,"finalfinal");
    
    setFinalMarkups(final)
  }

  useEffect(() => {
    getAllMarkups();
  }, [])
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "96vh",
        margin: "20px",
        marginRight: "0px",
        width: "90%",
        backgroundColor: "white",
        padding: "20px",
        borderRadius: "12px",
      }}
    >
      <Box sx={{ borderBottom: "1px solid #E5E5E8" }}>
        <QuoteRouteHeader
          pageTitle={`${!getShippingQuotes ? 'Result' : 'Get Shipping Quote'}`}
          currentRoute={`Result`}
          getShippingQuotes={getShippingQuotes}
        />
      </Box>
      <Box>
        {showQuote ? (
          <QuoteList setGetShippingQuotes={setGetShippingQuotes} setShowQuote={setShowQuote} getShippingQuotes={getShippingQuotes} formValues={formValues}/>
        ) : (
          <GetShippingQuote setGetShippingQuotes={setGetShippingQuotes} setShowQuote={setShowQuote} finalMarkups={finalMarkups} setFormValues={setFormValues}/>
        )}
      </Box>
    </Box>
  );
}
